module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/logo/affirm-icon-logo-4c9c61c942841be8e0099fda0040b926.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/logo/affirm-icon-logo.svg
// module id = Pktt
// module chunks = 24